import styled from 'styled-components';
import MenuItem, {MenuItemProps} from '@material-ui/core/MenuItem';
import React from 'react';
import {Typography} from '../../typography';
import Checkbox, {CheckboxProps} from '@material-ui/core/Checkbox';
import {AccentColorOptions, useAccentColor} from 'epic-ue-theme';
import CheckBoxSharpIcon from '@material-ui/icons/CheckBoxSharp';
import CheckBoxOutlineBlankSharpIcon from '@material-ui/icons/CheckBoxOutlineBlankSharp';
import classNames from 'classnames';

const CheckboxMenuItemWrapper: any = styled(MenuItem)<{$fillColor: string}>`
    &&& {
        &:first-child {
            margin-top: 16px;
        }
        margin: 0;
        padding-left: 0;
        border-radius: unset;
        color: ${(p) => p.theme.palette.common.black};
        min-height: 40px;
        height: 40px;
        &:last-child {
            margin-bottom: 20px;
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            &:first-child {
                margin-top: 6px;
            }
            &:last-child {
                margin-bottom: 6px;
            }
        }
    }
    &&&.selected {
        background-color: initial;
    }
    &&&:hover {
        background-color: initial;
        color: ${(p) => p.theme.palette.common.black};
    }
    &&.Mui-focusVisible {
        background-color: unset;
    }
    &&.Mui-focusVisible {
        background-color: initial;
        color: ${(p) => p.theme.palette.common.black};
    }

    .checkbox-option [class*='MuiSvgIcon-root'] {
        stroke: ${(p) => p.theme.palette.neutral.steel} !important;
    }

    &.sharp {
        .checkbox-option [class*='MuiSvgIcon-root'] {
            fill: ${(p) => p.theme.palette.neutral.steel} !important;
            stroke: #f7fafd !important;
        }
    }

    .checkbox-option.Mui-checked [class*='MuiSvgIcon-root'] {
        fill: ${(p) => p.$fillColor} !important;
        color: #fff !important;
        stroke: initial !important;
    }

    .checkbox-option.Mui-disabled [class*='MuiSvgIcon-root'] path {
        fill: ${(p) => p.theme.palette.neutral.stone} !important;
        color: ${(p) => p.theme.palette.neutral.stone} !important;
        stroke: ${(p) => p.theme.palette.neutral.steel} !important;
    }

    &&.MuiMenuItem-gutters {
        padding-left: 0px;
    }

    .paragraph {
        display: inline-block;
    }
`;

interface SelectInnerMenuItemProps extends MenuItemProps {
    children: React.ReactNode;
    checkboxProps?: CheckboxProps;
    accentColor?: AccentColorOptions;
    sharp?: boolean;
}

const SelectInnerMenuItem = ({
    children,
    itemRef,
    checkboxProps = {},
    accentColor = 'sky',
    sharp,
    ...props
}: SelectInnerMenuItemProps): JSX.Element => {
    const fillColor = useAccentColor(accentColor);
    if (sharp) {
        checkboxProps.icon = <CheckBoxOutlineBlankSharpIcon />;
        checkboxProps.checkedIcon = <CheckBoxSharpIcon />;
    }

    return (
        <CheckboxMenuItemWrapper
            ref={itemRef}
            className={classNames({sharp})}
            {...props}
            $fillColor={fillColor}>
            <Checkbox {...checkboxProps} className="checkbox-option" color="primary" />{' '}
            <Typography variant="p">{children}</Typography>
        </CheckboxMenuItemWrapper>
    );
};

export const CheckboxMenuItem = React.forwardRef<any, SelectInnerMenuItemProps>(
    (props, ref: any) => {
        return (
            <SelectInnerMenuItem itemRef={ref} {...props}>
                {props.children}
            </SelectInnerMenuItem>
        );
    }
);
